<script>
	import mapboxgl from "mapbox-gl";
	import MapboxLanguage from "@mapbox/mapbox-gl-language";
	import { uiText } from "../lib/uiText.js";
	// import "mapbox-gl/dist/mapbox-gl.css";
	import { onMount, onDestroy, createEventDispatcher } from "svelte"; // Add createEventDispatcher

	const dispatch = createEventDispatcher(); // Initialize dispatcher

	export let autoGeolocate = false; // Add the state prop

	console.log(autoGeolocate);

	let map;
	let mapContainer;
	let custom_image;

	let popupList = [];
	// let markerList = [];

	export let lang = "bg";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));

	let debug = {
		lat: "0",
		lng: 0,
		acc: 0,
	};

	// export let mapData = {
	// 	latConstraints: [42.15049, 42.148],
	// 	longConstraints: [24.73592, 24.73971],
	// 	zoomConstraints: [100, 500, 300],
	// 	pointAt: [42.149, 24.73681],
	// 	mapImage: {
	// 		url: "https://citati.top/test/map/map2.webp",
	// 		width: 1418,
	// 		height: 1256,
	// 	},
	// };

	export let mapData = {};
	export let customStyling;

	const mapData_reference = {
		bounds: {
			sw: [23.98116, 42.11312],
			ne: [24.75014, 42.70434],
		},
		center: [24.73732, 42.15029], //lat, lng
		geolocate: true,
		navigation: true,
		customMap: {
			animate: false,
			coordinates: {
				tl: [1, 2],
				tr: [3, 4],
				bl: [5, 6],
				br: [3, 4],
			},
			height: "",
			image: "",
			//or
			image: [
				{ zoom: 0, image: "ImageA.webp" },
				{ zoom: 5, image: "ImageB.webp" },
				{ zoom: 8, image: "ImageC.webp" },
				{ zoom: 12, image: "ImageD.webp" },
			],
			width: "",
		},
		markerStyling: "", //<style>#marker-1{height:50px;width:50px;background:blue}</style>
		markers: [
			{
				lnglat: [24.7383, 42.1507],
				options: {
					color: "red",
					rotation: 0,
					anchor: "center",
					draggable: true,
					element: false,
					rotationAlignment: "map",
					scale: 1,
				},
				popup: "0",
			},
			{
				lnglat: [24.738, 42.15],
				options: {
					color: "red",
					rotation: 0,
					anchor: "center",
					draggable: true,
					element: false,
					rotationAlignment: "map",
					scale: 1,
				},
				popup: "0",
			},
		], //or false
		markerVariants: 2,
		popups: [
			{
				lnglat: [24.738, 42.15],
				options: {
					closeOnMove: true,
					className: "text-red-800",
					focusAfterOpen: false,
				},
				html: "<h3><strong>This</strong> is a pop-up i guess!</h3>",
			},
		], // or false
		style: "mapbox://styles/emiltoteb/cm7i3e3uf00ia01s2fl6c0a4f",
		zoom: 15,
	};

	let lng, lat, zoom;
	function updateData() {
		zoom = map.getZoom();
		lng = map.getCenter().lng;
		lat = map.getCenter().lat;
	}

	let mapMessage = false;
	function handleMapMessage(message) {
		mapMessage = message.message;
		// console.log(message.message);
	}

	// Ray-casting algorithm for Point-in-Polygon / Player-in-Game-Area detection
	function isPointInPolygon(point, vs) {
		let x = point[0],
			y = point[1];
		let inside = false;
		for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
			let xi = vs[i][0],
				yi = vs[i][1];
			let xj = vs[j][0],
				yj = vs[j][1];
			let intersect =
				yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
			if (intersect) inside = !inside;
		}
		return inside;
	}

	// onMount(() => {
	// 	map = new mapboxgl.Map({
	// 		attributionControl: false, //hide attribution from map corner
	// 		container: mapContainer,
	// 		style: mapData.style,
	// 		accessToken:
	// 			"pk.eyJ1IjoiZW1pbHRvdGViIiwiYSI6ImNsazV1MHVndjAydm4zZnFnNHY1bTQzajAifQ.QMuUlYYWi-tfLUpwYbZzZw",
	// 		center: mapData.center,
	// 		zoom: mapData.zoom,
	// 		projection: "mercator",
	// 		maxPitch: 0,
	// 		maxBounds: [mapData.bounds.sw, mapData.bounds.ne],
	// 	});

	// 	if (mapData.geolocate) {
	// 		const geolocate = new mapboxgl.GeolocateControl({
	// 			positionOptions: {
	// 				enableHighAccuracy: true,
	// 			},
	// 			// When active the map will receive updates to the device's location as it changes.
	// 			trackUserLocation: true,
	// 			// Draw an arrow next to the location dot to indicate which direction the device is heading.
	// 			showUserHeading: true,
	// 		});
	// 		map.addControl(geolocate);
	// 		if (autoGeolocate) {
	// 			geolocate.trigger();
	// 		}

	// 		geolocate.on("trackuserlocationstart", () => {
	// 			dispatch("geoIntent", true);
	// 		});

	// 		// 2. Listen for the player turning tracking OFF
	// 		geolocate.on("trackuserlocationend", () => {
	// 			dispatch("geoIntent", false);
	// 		});

	// 		geolocate.on("error", () => {
	// 			handleMapMessage({
	// 				message: ui.map.error_generic,
	// 			});
	// 			// console.log("An error event has occurred.");
	// 		});

	// 		geolocate.on("outofmaxbounds", () => {
	// 			handleMapMessage({
	// 				message: ui.map.outside_of_play_area,
	// 			});
	// 			// console.log("An outofmaxbounds event has occurred.");
	// 		});

	// 		geolocate.on("geolocate", function (e) {
	// 			debug.lng = e.coords.longitude;
	// 			debug.lat = e.coords.latitude;
	// 			debug.acc = e.coords.accuracy;
	// 			var position = [debug.lng, debug.lat];
	// 			// console.log(position);
	// 			// console.warn(e);
	// 		});
	// 		// use this for location data on points

	// 		// Add the control to the map.
	// 		// map.addControl(geolocate);
	// 		// map.on('load', function() {
	// 		//   geolocate.trigger(); //<- Automatically activates geolocation
	// 		// });
	// 		// FORCE auto geo tracking on open
	// 	}

	// 	if (mapData.navigation) {
	// 		const nav = new mapboxgl.NavigationControl({
	// 			showZoom: true,
	// 			showCompass: true,
	// 		});
	// 		map.addControl(nav, "top-right");
	// 	}

	// 	if (mapData.popups) {
	// 		mapData.popups.forEach((popup, i) => {
	// 			popupList[i] = new mapboxgl.Popup(popup.options)
	// 				.setLngLat(popup.lnglat)
	// 				.setHTML(popup.html)
	// 				.addTo(map);

	// 			// console.log(popupList);
	// 		});
	// 	}

	// 	if (mapData.markers) {
	// 		mapData.markers.forEach((marker, i) => {
	// 			// console.log(marker);

	// 			const el = document.createElement("div");
	// 			el.classList = "oblsk-marker";
	// 			el.id = "marker-" + i;
	// 			// Create a default Marker, colored black, rotated 45 degrees.
	// 			if (marker.popup) {
	// 				const Marker = new mapboxgl.Marker(el, marker.options)
	// 					.setLngLat(marker.lnglat)
	// 					.setPopup(popupList[marker.popup])
	// 					.addTo(map);

	// 				// console.log(marker.popup);
	// 			} else {
	// 				const Marker = new mapboxgl.Marker(el, marker.options)
	// 					.setLngLat(marker.lnglat)
	// 					.addTo(map);
	// 			}
	// 		});
	// 	}

	// 	if (mapData.customMap) {
	// 		const canvas = document.getElementById("customMapCanvas");
	// 		const ctx = canvas.getContext("2d");

	// 		function setCustomImage() {
	// 			custom_image = new Image();
	// 			custom_image.crossOrigin = "anonymous";

	// 			if (typeof mapData.customMap.image === "object") {
	// 				// let keys = Object.keys(mapData.customMap.image)
	// 				// let values = Object.values(mapData.customMap.image)

	// 				custom_image.src = mapData.customMap.image[0].image;

	// 				for (let i = 0; i < mapData.customMap.image.length; i++) {
	// 					if (zoom >= mapData.customMap.image[i].zoom) {
	// 						custom_image.src = mapData.customMap.image[i].image;
	// 					} else {
	// 						break; // Stop at the first zoom level higher than the current zoom
	// 					}
	// 				}

	// 				// if (zoom < 12) {
	// 				// 	custom_image.src = "https://placehold.co/1600/transparent/0F0";
	// 				// } else if (zoom > 12 && zoom < 15) {
	// 				// 	custom_image.src = "https://placehold.co/1600/transparent/F00";
	// 				// } else if (zoom > 15) {
	// 				// 	custom_image.src = "https://placehold.co/1600/transparent/00F";
	// 				// }
	// 			} else {
	// 				custom_image.src = mapData.customMap.image;
	// 			}

	// 			custom_image.onload = function () {
	// 				ctx.drawImage(custom_image, 0, 0);
	// 			};
	// 		}

	// 		setCustomImage();

	// 		map.on("load", () => {
	// 			if (mapData.polygons) {
	// 				mapData.polygons.forEach((poly, i) => {
	// 					const sourceId = "poly-source-" + (poly.id || i);

	// 					// Add the GeoJSON source
	// 					map.addSource(sourceId, {
	// 						type: "geojson",
	// 						data: {
	// 							type: "Feature",
	// 							geometry: {
	// 								type: "Polygon",
	// 								coordinates: poly.coordinates,
	// 							},
	// 						},
	// 					});

	// 					// Add the Fill layer
	// 					map.addLayer({
	// 						id: "poly-fill-" + (poly.id || i),
	// 						type: "fill",
	// 						source: sourceId,
	// 						paint: {
	// 							"fill-color": poly.fillColor || "#000000",
	// 							"fill-opacity": poly.fillOpacity || 0.3,
	// 						},
	// 					});

	// 					// Add the Border layer
	// 					map.addLayer({
	// 						id: "poly-border-" + (poly.id || i),
	// 						type: "line",
	// 						source: sourceId,
	// 						paint: {
	// 							"line-color": poly.borderColor || "#000000",
	// 							"line-width": poly.borderWidth || 2,
	// 							// Conditionally apply dashed borders
	// 							...(poly.borderDasharray
	// 								? { "line-dasharray": poly.borderDasharray }
	// 								: {}),
	// 						},
	// 					});
	// 				});
	// 			}

	// 			if (mapData.customMap) {
	// 				map.addSource("canvas-source", {
	// 					type: "canvas",
	// 					canvas: "customMapCanvas",
	// 					coordinates: [
	// 						mapData.customMap.coordinates.tl,
	// 						mapData.customMap.coordinates.tr,
	// 						mapData.customMap.coordinates.bl,
	// 						mapData.customMap.coordinates.br,
	// 					],
	// 					animate: mapData.customMap.animate,
	// 				});

	// 				map.addLayer({
	// 					id: "canvas-layer",
	// 					type: "raster",
	// 					source: "canvas-source",
	// 				});

	// 				map.moveLayer("canvas-layer", "national-park");
	// 			}
	// 			// var layers = map.getStyle().layers;
	// 			// // var layerId = layers[i].id;
	// 			// console.log(layers);
	// 		});

	// 		map.on("move", () => {
	// 			updateData();
	// 			setCustomImage();
	// 		});
	// 	}

	// 	const language = new MapboxLanguage({
	// 		defaultLanguage: lang == "bg" ? "mul" : "en",
	// 	});
	// 	map.addControl(language);
	// });

	onMount(() => {
		map = new mapboxgl.Map({
			attributionControl: false, //hide attribution from map corner
			container: mapContainer,
			style: mapData.style,
			accessToken:
				"pk.eyJ1IjoiZW1pbHRvdGViIiwiYSI6ImNsazV1MHVndjAydm4zZnFnNHY1bTQzajAifQ.QMuUlYYWi-tfLUpwYbZzZw",
			center: mapData.center,
			zoom: mapData.zoom,
			projection: "mercator",
			maxPitch: 0,
			maxBounds: [mapData.bounds.sw, mapData.bounds.ne],
		});

		// Scope this higher so the map.on('load') event can see it
		let geolocateControl;

		if (mapData.geolocate) {
			geolocateControl = new mapboxgl.GeolocateControl({
				positionOptions: {
					enableHighAccuracy: true,
				},
				trackUserLocation: true,
				showUserHeading: true,
			});
			map.addControl(geolocateControl);

			geolocateControl.on("trackuserlocationstart", () => {
				dispatch("geoIntent", true);
			});

			geolocateControl.on("trackuserlocationend", () => {
				dispatch("geoIntent", false);
			});

			geolocateControl.on("error", () => {
				handleMapMessage({
					message: ui.map.error_generic,
				});
			});

			geolocateControl.on("outofmaxbounds", () => {
				handleMapMessage({
					message: ui.map.outside_of_play_area,
				});
			});

			geolocateControl.on("geolocate", function (e) {
				debug.lng = e.coords.longitude;
				debug.lat = e.coords.latitude;
				debug.acc = e.coords.accuracy;
				var position = [debug.lng, debug.lat];

				// --- Custom Polygon Geofence Check ---
				if (mapData.polygons) {
					// Find the specific polygon acting as the game zone
					const playAreaPoly = mapData.polygons.find(
						(p) => p.isPlayArea === true,
					);

					if (playAreaPoly) {
						// GeoJSON polygons are nested arrays: coordinates[0] is the outer boundary ring
						const isInside = isPointInPolygon(
							position,
							playAreaPoly.coordinates[0],
						);

						if (!isInside) {
							handleMapMessage({
								message: ui.map.outside_of_play_area,
							});
						}
					}
				}
				// -------------------------------------
			});
		}

		if (mapData.navigation) {
			const nav = new mapboxgl.NavigationControl({
				showZoom: true,
				showCompass: true,
			});
			map.addControl(nav, "top-right");
		}

		if (mapData.popups) {
			mapData.popups.forEach((popup, i) => {
				popupList[i] = new mapboxgl.Popup(popup.options)
					.setLngLat(popup.lnglat)
					.setHTML(popup.html)
					.addTo(map);
			});
		}

		if (mapData.markers) {
			mapData.markers.forEach((marker, i) => {
				const el = document.createElement("div");
				el.classList = "oblsk-marker";
				el.id = "marker-" + i;

				if (marker.popup) {
					const Marker = new mapboxgl.Marker(el, marker.options)
						.setLngLat(marker.lnglat)
						.setPopup(popupList[marker.popup])
						.addTo(map);
				} else {
					const Marker = new mapboxgl.Marker(el, marker.options)
						.setLngLat(marker.lnglat)
						.addTo(map);
				}
			});
		}

		// Prepare the custom image source BEFORE the map loads, but don't attach layers yet
		if (mapData.customMap) {
			const canvas = document.getElementById("customMapCanvas");
			const ctx = canvas.getContext("2d");

			function setCustomImage() {
				custom_image = new Image();
				custom_image.crossOrigin = "anonymous";

				if (typeof mapData.customMap.image === "object") {
					custom_image.src = mapData.customMap.image[0].image;

					for (let i = 0; i < mapData.customMap.image.length; i++) {
						if (zoom >= mapData.customMap.image[i].zoom) {
							custom_image.src = mapData.customMap.image[i].image;
						} else {
							break;
						}
					}
				} else {
					custom_image.src = mapData.customMap.image;
				}

				custom_image.onload = function () {
					ctx.drawImage(custom_image, 0, 0);
				};
			}

			setCustomImage();

			map.on("move", () => {
				updateData();
				setCustomImage();
			});
		}

		// --- THE MASTER LOAD EVENT ---
		// Everything inside here executes only AFTER the base map style is fully rendered
		map.on("load", () => {
			// 1. Fire the Auto-Geolocate safely
			if (mapData.geolocate && autoGeolocate && geolocateControl) {
				geolocateControl.trigger();
			}

			// 2. Draw Polygons (Now separated from customMap!)
			if (mapData.polygons) {
				mapData.polygons.forEach((poly, i) => {
					if (poly.invisible) return;

					const sourceId = "poly-source-" + (poly.id || i);

					map.addSource(sourceId, {
						type: "geojson",
						data: {
							type: "Feature",
							geometry: {
								type: "Polygon",
								coordinates: poly.coordinates,
							},
						},
					});

					map.addLayer({
						id: "poly-fill-" + (poly.id || i),
						type: "fill",
						source: sourceId,
						paint: {
							"fill-color": poly.fillColor || "#000000",
							"fill-opacity": poly.fillOpacity || 0.3,
						},
					});

					map.addLayer({
						id: "poly-border-" + (poly.id || i),
						type: "line",
						source: sourceId,
						paint: {
							"line-color": poly.borderColor || "#000000",
							"line-width": poly.borderWidth || 2,
							...(poly.borderDasharray
								? { "line-dasharray": poly.borderDasharray }
								: {}),
						},
					});
				});
			}

			// 3. Attach Custom Map Canvas Layers
			if (mapData.customMap) {
				map.addSource("canvas-source", {
					type: "canvas",
					canvas: "customMapCanvas",
					coordinates: [
						mapData.customMap.coordinates.tl,
						mapData.customMap.coordinates.tr,
						mapData.customMap.coordinates.bl,
						mapData.customMap.coordinates.br,
					],
					animate: mapData.customMap.animate,
				});

				map.addLayer({
					id: "canvas-layer",
					type: "raster",
					source: "canvas-source",
				});

				map.moveLayer("canvas-layer", "national-park");
			}
		});

		const language = new MapboxLanguage({
			defaultLanguage: lang == "bg" ? "mul" : "en",
		});
		map.addControl(language);
	});

	onDestroy(() => {
		map.remove();
	});

	let el = document.getElementById("#marker");
</script>

{#if mapMessage != false}
	<button
		on:click={() => (mapMessage = false)}
		class="default fixed bottom-9 w-max m-auto text-center map-message bg-black left-0 right-0 bg-opacity-50 text-white p-4 z-20"
	>
		{mapMessage}
	</button>
{/if}

<div class="map" bind:this={mapContainer} />

{#if customStyling}
	{@html customStyling}
{/if}

{#if mapData.markerStyling}
	{@html mapData.markerStyling}
{/if}

{#if mapData.customMap}
	<canvas
		id="customMapCanvas"
		width={mapData.customMap.width}
		height={mapData.customMap.height}
		style="display:none; opacity:0; position:absolute;"
	/>
{/if}

<!-- DEBUG ONLY -->
{#if mapData.debug}
	<div
		class="debug-panel absolute z-10 bottom-4 left-0 right-0 m-auto bg-black p-4 text-center"
	>
		DEBUG — LNG: {debug.lng} — LAT: {debug.lat} — ACC: {debug.acc} — DEBUG
	</div>
{/if}

<!-- END DEBUG -->

<style>
	.map {
		/* position: absolute; */
		width: 100%;
		height: 100%;
	}
</style>
